import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import OmnichannelInboxComponent from 'components/OmnichannelInbox';
import { useOmnichannelInboxEnabled } from 'hooks';
import { SubscriptionsStatus } from 'reducers/subscriptions/SubscriptionsState';
import { NotAllowedPath } from 'routes/Paths';
import { RootState } from 'store';
import PrivatePage from './PrivatePage';

export const OmnichannelInbox: FunctionComponent = () => {
    const omnichannelInboxEnabled = useOmnichannelInboxEnabled();
    const subscriptionsStatus = useSelector((state: RootState) => state.subscriptions.status);
    const subscriptionsResolved =
        subscriptionsStatus === SubscriptionsStatus.FetchSuccess || subscriptionsStatus === SubscriptionsStatus.Error;

    // Wait until subscriptions resolve so a refresh does not bounce /inbox to bookings
    // before premium access is known. Then keep users without access off this page.
    if (subscriptionsResolved && !omnichannelInboxEnabled) {
        return <Redirect to={NotAllowedPath} />;
    }

    return (
        <PrivatePage
            title="Inbox - Cuddles"
            pageName="/inbox"
        >
            <OmnichannelInboxComponent />
        </PrivatePage>
    );
};

export default OmnichannelInbox;
